import { authenticatedFetch } from "../utils/api";
import { API_HOST } from "../utils/constants";

const workflowUrl = (projectId, suffix = "") => (
  `${API_HOST}/api/narration-projects/${projectId}/workflow${suffix}`
);

const request = (projectId, suffix = "", options = {}) => (
  authenticatedFetch(workflowUrl(projectId, suffix), options)
);

export const fetchNarrationWorkflow = (projectId) => request(projectId);

export const saveNarrationSource = (projectId, payload) => request(projectId, "/source", {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const previewNarrationEpisodes = (projectId, payload = {}) => request(projectId, "/episodes/preview", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const confirmNarrationEpisodes = (projectId, payload = {}) => request(projectId, "/episodes/confirm", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const analyzeNarrationAssets = (projectId, payload = {}) => request(projectId, "/assets/analyze", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const saveNarrationAssetBible = (
  projectId,
  assetBible,
  expectedSourceRevision,
) => request(projectId, "/assets/bible", {
  method: "PUT",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ assetBible, expectedSourceRevision }),
});

export const confirmNarrationAssetBible = (projectId) => request(projectId, "/assets/bible/confirm", {
  method: "POST",
});

export const startNarrationStage = (projectId, payload) => request(projectId, "/tasks/start", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const reserveNarrationStage = (projectId, payload) => request(projectId, "/tasks/reserve", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const releaseNarrationStage = (projectId, payload) => request(projectId, "/tasks/release", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const completeNarrationStage = (projectId, payload) => request(projectId, "/tasks/complete", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const failNarrationStage = (projectId, payload) => request(projectId, "/tasks/fail", {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(payload),
});

export const confirmNarrationAssets = (projectId) => request(projectId, "/assets/confirm", {
  method: "POST",
});

export const validateNarrationStoryboards = (projectId) => request(projectId, "/storyboards/validate", {
  method: "POST",
});

export const confirmNarrationStoryboards = (projectId) => request(projectId, "/storyboards/confirm", {
  method: "POST",
});

export const confirmNarrationQa = (projectId) => request(projectId, "/qa/confirm", {
  method: "POST",
});

export const stopNarrationWorkflow = (projectId) => request(projectId, "/stop", {
  method: "POST",
});

export const resumeNarrationWorkflow = (projectId) => request(projectId, "/resume", {
  method: "POST",
});
